import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { onRegister } from "../../redux/homeAction";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import CaptchaInput from "../Captcha/CaptchaInput";
import SocialLogin from "../SocialLogin/SocialLogin";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const [input, setInput] = useState("");
  const [referralCode, setReferralCode] = useState(null);
  const [loader, setLoader] = useState(false);
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;

  const onInputHandler = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const captchaInputHandler = (e) => {
    setInput({ ...input, quizCode: e.target.value });
  };

  const handleCaptchaChange = (captchaText) => {
    setCaptchaValue(captchaText);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("verified") === "true") {
      toast.success("Email verified successfully!");
    }
    const refCode = params.get("ref");
    if (refCode) {
      setReferralCode(refCode);
    }
  }, []);

  const onHandleRegister = (e) => {
    e.preventDefault();
    if (!input.name) {
      toast.error("Please enter a user name");
    } else if (!input.fullName) {
      toast.error("Please enter a full name");
    } else if (!input.email) {
      toast.error("Please enter a email");
    } else if (!emailRegex.test(input.email)) {
      toast.error("Please enter a correct email");
    } else if (!input.password) {
      toast.error("Please enter a password");
    } else if (input.password.length < 8) {
      toast.error("The password must be at least 8 characters");
    } else if (input.password.length > 15) {
      toast.error("Password must not exceed 15 characters");
    } else if (!input.repeatPassword) {
      toast.error("Please enter a repeat password");
    } else if (input.password !== input.repeatPassword) {
      toast.error("Password and confirm password should match");
    } else if (!input.quizCode) {
      toast.error("Please enter captcha code");
    } else if (input.quizCode !== captchaValue) {
      toast.error("Captcha Code Not Correct");
    } else if (!input.termsAccepted) {
      toast.error("Please accept the Terms and Conditions");
    } else {
      setLoader(true);
      const data = {
        email: input.email,
        username: input.name,
        password: input.password,
        full_name: input.fullName,
      };
      if (referralCode) data.ref = referralCode;
      dispatch(onRegister(data, setLoader, navigate));
    }
  };

  return (
    <>
      <section id="register">
        <div className="register_content">
          <div className="row gy-5">
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div className="register-container">
                <div className="text-start mb-3">
                  <Link to="/" className="back-button">
                    <i className="fas fa-arrow-left me-2"></i>Back
                  </Link>
                </div>
                <div className="text-center">
                  <h1>
                    Welcome to <span className="color_yellow">Triunfador</span>
                  </h1>
                  <p className="mb-4">
                    Welcome to the world of FREE sports betting! Complete this registration form with your correct information and start being part of the Triunfador family.
                  </p>
                </div>

                <SocialLogin 
                  onSuccess={(result) => {
                    dispatch({
                      type: 'ONLOGIN',
                      payload: result
                    });
                  }}
                  onError={(error) => {
                    setLoader(false);
                    toast.error(error.message);
                  }}
                />

                <div className="divider">
                  <span>or</span>
                </div>

                <form onSubmit={onHandleRegister}>
                  <div className="row gy-3">
                    <div className="col-md-6">
                      <div className="form-group floating">
                        <input
                          type="text"
                          className="form-control floating input"
                          name="name"
                          value={input.name}
                          onChange={onInputHandler}
                        />
                        <label>Username</label>
                        <div className="input_icon">
                          <i className="fa-regular fa-user" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group floating position-relative">
                        <input
                          type="text"
                          className="form-control floating input"
                          name="fullName"
                          value={input.fullName}
                          onChange={onInputHandler}
                        />
                        <label>Full Name</label>
                        <div className="input_icon">
                          <i className="fa-regular fa-user" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group floating position-relative">
                        <input
                          type="email"
                          className="form-control floating input"
                          name="email"
                          value={input.email}
                          onChange={onInputHandler}
                        />
                        <label>E-mail</label>
                        <div className="input_icon">
                          <i className="fa-regular fa-envelope" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group floating position-relative">
                        <input
                          type={showPassword1 ? "text" : "password"}
                          className="form-control floating input"
                          name="password"
                          value={input.password}
                          onChange={onInputHandler}
                        />
                        <label>Password</label>
                        <div className="input_icon">
                          {showPassword1 ? (
                            <i className="fa-regular fa-eye" onClick={() => setShowPassword1(false)} />
                          ) : (
                            <i className="fa fa-eye-slash" onClick={() => setShowPassword1(true)} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group floating position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control floating input"
                          name="repeatPassword"
                          value={input.repeatPassword}
                          onChange={onInputHandler}
                        />
                        <label>Repeat Password</label>
                        <div className="input_icon">
                          {showPassword ? (
                            <i className="fa-regular fa-eye" onClick={() => setShowPassword(false)} />
                          ) : (
                            <i className="fa fa-eye-slash" onClick={() => setShowPassword(true)} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <CaptchaInput
                        value={input.quizCode || ""}
                        onChange={captchaInputHandler}
                        onCaptchaChange={handleCaptchaChange}
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="control control--checkbox register">
                        <input
                          type="checkbox"
                          checked={input.termsAccepted}
                          onChange={(e) => setInput({ ...input, termsAccepted: e.target.checked })}
                        />
                        <span className="small-text">
                          By checking this box, I confirm that I am 18 years of age or older and have read and agreed to Triunfador's <Link to="/term-condition">Terms and Conditions</Link>, <Link to="/privacy-policy">Privacy Policy</Link>, and <Link to="/cookies-policy">Cookie Policy</Link>.
                        </span>
                        <div className="control__indicator" />
                      </label>
                    </div>
                    <div className="col-md-12">
                      {loader ? (
                        <Loader />
                      ) : (
                        <input type="submit" className="input submit_input" value="Play Now" />
                      )}
                    </div>
                  </div>
                </form>
                <Link to="/login" className="text_normal">
                  Have an account?
                  <span className="color_yellow">Log in</span>
                </Link>
              </div>
            </div>
            <div className="col-lg-6 d-flex align-items-center">
              <div className="login_right">
                <img src="./images/login_right.png" className="img-fluid" alt="Register" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;